import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn/ui 스타일 컴포넌트용 클래스 병합 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
